import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import ButtonLink from '~components/ui/ButtonLink'

const CartHeading = ({ className, breadcrumbs, title, border = true, basket }) => {
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  };

  return (
    <div className={classNames('w-full', className)}>
      <div className="xxl:container mx-auto px-4 md:px-8 xxl:px-0">
        <div className={classNames({ 'border-coral border-b pb-4 xxl:pb-8': border })}>
          {breadcrumbs &&
            <div className="inline-flex mb-3 md:mb-2">
              {breadcrumbs.map((breadcrumb, index) => (
                <span key={index}>
                  {breadcrumb.url ? (
                    <Link className="mx-1 hover:underline focus:underline" to={breadcrumb.url}>
                      {capitalizeFirstLetter(breadcrumb.title)}
                    </Link>
                  ) : (
                    <span className="mx-1">
                      {capitalizeFirstLetter(breadcrumb.title)}
                    </span>
                  )}
                  
                  {index !== breadcrumbs.length - 1 && (
                    <span className="inline">/</span>
                  )}
                </span>
              ))}
            </div>
          }

          <div className="flex flex-col items-start md:flex-row md:items-center md:justify-between">
            <h1 className="text-3xl m-0 md:text-4xl xxl:text-7xl">
              {capitalizeFirstLetter(title)}
            </h1>

            {basket && (
              <ButtonLink
                href="/shop"
                theme="secondary"
                className="mt-4 md:mt-0 sm:w-auto"
              >
                Continue shopping
              </ButtonLink>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CartHeading.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  })),
  title: PropTypes.string.isRequired,
  border: PropTypes.bool,
  basket: PropTypes.bool
}

export default CartHeading